import Forbidden from 'src/pages/Error/Forbidden';
import InternalServer from 'src/pages/Error/InternalServer';
import NotFound from 'src/pages/Error/NotFound';
import SigninOidc from 'src/pages/SigninOidc';
import SignoutCallbackOidc from 'src/pages/SignoutCallBackOidc';
import SignoutOidc from 'src/pages/SignoutOidc';
import type { RouteGroup } from './types';

export const authRoutes: RouteGroup = [
  // Authentication Routes
  {
    path: '/signin-oidc',
    Component: SigninOidc
  },
  {
    path: '/signout-callback-oidc',
    Component: SignoutCallbackOidc
  },
  {
    path: '/signout-oidc',
    Component: SignoutOidc
  }
];

export const errorRoutes: RouteGroup = [
  // Error Pages
  {
    path: '/forbidden',
    Component: Forbidden
  },
  {
    path: '/internal-server-error',
    Component: InternalServer
  },
  {
    path: '*',
    Component: NotFound
  }
];
